export type ClipboardType = {
    clipboardCopy: string;
};
